import { useFilmOtt } from './use-film-ott';

export const useFilmStreams = (contentId: string) => {
    const filmOtt = useFilmOtt(contentId);

    return filmOtt?.onlineStreams?.streams;
};
